export const formTheme = {
  colors: {
    statusOk: 'green',
    statusCritical: 'red',
    statusDisabled: 'grey',
  },
};
